export enum Orientation {
  Desktop = 'Desktop',
  Landscape = 'Landscape',
  Portrait = 'Portrait',
}

export default function detectOrientation(isDesktop: boolean, isPortrait: boolean): Orientation {
  if (isDesktop) return Orientation.Desktop;
  return isPortrait ? Orientation.Portrait : Orientation.Landscape;
}
